<template>
    <div class="font">
        <span>请在电脑端打开该地址</span>
    </div>
</template>

<script>
    export default {
        name: "onlyPC"
    }
</script>

<style scoped>
    .font{
        text-align: center;
        margin-top:20%;
        font-size:20px;
    }
</style>